export enum Day {
  TODAY = "today",
  TOMORROW = "tomorrow",
  ANOTHER_DAY = "another_day",
  YESTERDAY = "yesterday",
  THIS_WEEK = "this_week",
  THIS_MONTH = "this_month",
}
